import React from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import useStyles from './style';
import { useScript } from '../../../utils/hooks';
import Grid from '../../../components/molecules/Grid';
import Typography from '../../../components/atoms/Typography';
import PropTypes from 'prop-types';
import { decodeHTML } from '../../../utils/decodeHTML';
import withErrorBoundary from '../../../utils/HOCs/withErrorBoundary';
import { COMPONENT_NAME } from './locators';

const TermsAndCondition = props => {
  const { headerText, termsAndConditionData, scriptURL } = props.fields;
  const classes = useStyles(props);

  const snippet =
    termsAndConditionData &&
    termsAndConditionData.value &&
    decodeHTML(termsAndConditionData.value);

  useScript(scriptURL && scriptURL.value);
  return (
    <Grid container justify="center" className={classes.root} data-locator={COMPONENT_NAME}>
      <Grid container justify="flex-start" className={classes.header}>
        <Grid item xs={12}>
          <Typography variant="h2" component="h2">
            <Text field={headerText} />
          </Typography>
        </Grid>
      </Grid>
      {snippet && (<Grid container md={12} lg={10} className={classes.content}>
        <Grid item>
          {scriptURL && scriptURL.value && (
            <div dangerouslySetInnerHTML={{ __html: snippet }} />
          )}
        </Grid>
      </Grid>)}
    </Grid>
  );
};

TermsAndCondition.propTypes = {
  backgroundColor: PropTypes.string,
  fields: PropTypes.shape({
    headerText: PropTypes.object,
    termsAndConditionData: PropTypes.object,
    scriptURL: PropTypes.object,
  }),
};

export default withErrorBoundary(TermsAndCondition);
